import {authAxios} from "./axiosClient";
import Cookies from 'universal-cookie';
import { dangKyWFHQLyURL, dangKyWFHURL, detailWFHURL, listThietBiWFHURL} from "../constants";

const cookies = new Cookies();

export const ListThietBiTruyCapApi = (params={})=>{
        const url = listThietBiWFHURL;
        return authAxios().get(url,{params});
}

export const GetDangKyWFHApi = (params={})=>{
        const url = dangKyWFHURL;
        return authAxios().get(url,{params});
}

export const PostDangKyWFHApi = (params={})=>{
        const url = dangKyWFHURL;
        return authAxios().post(url,params);
}

export const GetDangKyWFHQLyApi = (params={})=>{
        const url = dangKyWFHQLyURL;
        return authAxios().get(url,{params});
}

export const PutDKWFHQLyApi = (params={})=>{
        const url = dangKyWFHQLyURL;
        return authAxios().put(url,params);
}

export const GetDetailWFHApi =(params={})=> {
    const url = detailWFHURL;
    return authAxios().get(url(params));
}
